import { toast } from "react-toastify";
import React, { useCallback, useEffect, useState } from "react";
import "../styles/accounts.css";
import { FaRupeeSign } from "react-icons/fa";
import axios from "axios";
import validateVoucherPurchaseForm from "../utilities/validateVoucherPurchaseForm";
import Loader from "../components/Loader";
import API_BASE_URL from "../utilities/apiConfig";
import voucherDateAndTimeFormatter from "../utilities/voucherDateAndTimeFormatter";
import { FaClipboardList } from "react-icons/fa";
import { GrDocumentMissing } from "react-icons/gr";

import { useSelector } from "react-redux";
import {
  MDBInput,
  MDBBadge,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBBtn,
  MDBInputGroup,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import fromatDateintoDDMMMMYYYY from "../utilities/fromatDateintoDDMMMMYYYY";
import { Sticky } from "react-bootstrap-icons";
import DataTable from "../components/DataTable";
import convertToUnderscoreFormat from "../utilities/convertToUnderscoreFormat";
import debounce from "lodash/debounce";
import VoucherDataTable from "../components/VoucherDataTable";
import axiosInstance from "../utilities/apiConfig";

const Accounts = () => {
  const [customerType, setCustomerType] = useState("#");
  const [masterVoucherList, setMasterVoucherList] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isMissingVoucherDetails, setIsMissingVoucherDetails] = useState(false);
  const [bookAndSerialNo, setBookAndSerialNo] = useState({
    nextBookNo: "",
    nextSerialNo: "",
  });

  const intialVoucherDeatilsState = {
    voucherBookNo: "",
    voucherId: "",
    voucherSrNo: "",
    voucherType: "",
  };
  const [selectedVoucherDetails, setSelectedVoucherDetails] = useState(
    intialVoucherDeatilsState
  );

  const emptyVoucherPurchaseForm = {
    voucherId: "",
    purchaserType: "",
    advocateBarId: "",
    providedSerialNo: "",
    quantity: 1,
    userId: "",
  };
  const [voucherPurchaseForm, setVoucherPurchaseForm] = useState(
    emptyVoucherPurchaseForm
  );

  const [voucherDetailsList, setVoucherDetailsList] = useState([]);
  const [missingVoucherDetailsList, setMissingVoucherDetailsList] = useState(
    []
  );
  const [refresh, setRefresh] = useState(0);
  const [purchaserName, setPurchaserName] = useState("");
  const [purchaserType, setPurchaserType] = useState("");
  const userDetails = useSelector((state) => state.auth?.userData?.authUser);
  const { userId } = userDetails;
  const token = useSelector((state) => state.auth.token);

  const soldVoucherTableColumns = [
    {
      field: "id",
      headerName: "ID",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherType",
      headerName: "Voucher Type",
      type: "text",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherBookNo",
      headerName: "Book No",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherSrNo",
      headerName: "Sr No",
      type: "number",
      minWidth: 90,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherAmount",
      headerName: "Amount",
      type: "number",
      minWidth: 90,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "name",
      headerName: "Purchaser Name",
      minWidth: 130,
      flex: 1.5,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "purchaserType",
      headerName: "Purchaser Type",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "uttrakhandBarId",
      headerName: "Purchaser ID",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherPurchaseDate",
      headerName: "Purchase Date",
      minWidth: 160,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
  ];

  const missingVoucherTableColumns = [
    {
      field: "id",
      headerName: "ID",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherType",
      headerName: "Voucher Type",
      type: "text",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherBookNo",
      headerName: "Book No",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherSrNo",
      headerName: "Sr No",
      type: "number",
      minWidth: 90,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherAmount",
      headerName: "Amount",
      type: "number",
      minWidth: 90,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherMissingDate",
      headerName: "Date",
      minWidth: 160,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
  ];

  const handleSelectCustomer = (event) => {
    setCustomerType(event.target.value);
    setVoucherPurchaseForm({
      ...voucherPurchaseForm,
      purchaserType: event.target.value,
    });
  };

  const handleGetAllVoucherType = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/Accounting/get_master_list`);
      console.log("master voucher list", response.data);

      if (response.data.response.statusCode === 200) {
        setMasterVoucherList(response.data.vouchers);
      }
    } catch (error) {
      console.log("master voucher list api Error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetVoucherDetailsByVoucherId = async (voucherId) => {
    try {
      setLoading(true);
      console.log(voucherId);
      const response = await axiosInstance.get(
        `/Accounting/get_voucher_details/${voucherId}`
      );
      console.log("master voucher selected voucher details", response.data);
      if (response.data.response.statusCode === 200) {
        setSelectedVoucherDetails(response.data.voucher);
        setVoucherPurchaseForm({
          ...voucherPurchaseForm,
          voucherId: response.data.voucher.voucherId,
          providedSerialNo: response.data.voucher.voucherSrNo,
        });

        setBookAndSerialNo({
          nextSerialNo: response.data.voucher.voucherSrNo,
          nextBookNo: response.data.voucher.voucherBookNo,
        });
      }
    } catch (error) {
      console.log("master voucher selected voucher api Error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCalulateAmount = () => {
    setTotalAmount(
      voucherPurchaseForm?.quantity * selectedVoucherDetails?.voucherAmount
    );
  };

  const handlePurchaseVoucher = async () => {
    console.log("data for voucher fees details", voucherPurchaseForm);
    // Validate the emptyVoucherPurchaseForm
    const validationErrors = validateVoucherPurchaseForm(voucherPurchaseForm);

    // Check if there are any errors
    if (Object.keys(validationErrors).length === 0) {
      console.log("emptyVoucherPurchaseForm is valid!");
      try {
        setLoading(true);
        const response = await axiosInstance.post(
          `/Accounting/post_voucher_fee_details`,
          voucherPurchaseForm,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        );
        console.log("Voucher Purchase Form Response", response.data);
        // Optionally show success toast
        if (response.data.statusResponse.statusCode === 200) {
          toast.success(response.data.statusResponse.status);
          setBookAndSerialNo({
            nextSerialNo: response.data.voucherDetails?.nextSrNo,
            nextBookNo: response.data.voucherDetails?.nextBookNo,
          });
          setVoucherPurchaseForm({
            ...voucherPurchaseForm,
            providedSerialNo: response.data.voucherDetails?.nextSrNo,
          });
          setRefresh(refresh + 1);
        } else {
          toast.error(response.data.statusResponse.status);
        }
      } catch (error) {
        console.log("Voucher Purchase Form Error", error);
        toast.error("Failed to purchase voucher. Please try again later.");
      } finally {
        setLoading(false);
      }
    } else {
      console.log("Validation errors:", validationErrors);
      // Display error toast for each validation error
      Object.values(validationErrors).forEach((errorMessage) => {
        toast.error(errorMessage);
      });
    }
  };

  const handleGetSoldVoucherDetailsByUserId = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `/Accounting/get_voucher_details_by_user_id/${userId}`
      );

      console.log(
        "this is handle get voucher details by user id",
        response.data
      );
      if (response.data.response.statusCode === 200) {
        console.log(response.data.voucherDetailsList);
        setVoucherDetailsList(response.data?.voucherDetailsList);
        setIsMissingVoucherDetails(false);
        // toast.success(response.data.response.status);
      } else {
        // toast.error(response.data.response.status);
      }
    } catch (error) {
      // toast.error(`Error: ${error.message}`);
      console.log(
        " thsi is error mesage form voucher details get using  user id",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  const handleGetMissingVoucherDetailsByUserId = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Accounting/get_missing_voucher_details_by_user_id/${userId}`
      );

      console.log(
        "this is handle get missing voucher details by user id",
        response.data
      );
      if (response.data.response.statusCode === 200) {
        console.log(response.data.voucherDetailsList);
        setMissingVoucherDetailsList(response.data?.voucherDetailsList);
        setIsMissingVoucherDetails(true);
        // toast.success(response.data.response.status);
      } else {
        // toast.error(response.data.response.status);
      }
    } catch (error) {
      // toast.error(`Error: ${error.message}`);
      console.log(
        " thsi is error mesage form voucher details get using  user id",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  const handlefetchPurchaserName = async (purchaserId) => {
    setLoading(true);
    const formattedPurchaserId = convertToUnderscoreFormat(purchaserId);
    console.log(formattedPurchaserId);
    try {
      const response = await axiosInstance.get(
        `/Accounting/get_purchaser_name_by_id/${formattedPurchaserId}`
      );
      console.log(response.data);
      if (response.data.response.statusCode === 200) {
        setPurchaserName(response.data.name);
        setPurchaserType(response.data.pruchaserType);
      } else {
        setPurchaserName("");
        toast.error(response.data.response.status);
      }
    } catch (err) {
      setPurchaserName("");
      toast.error(
        "an unexpected error occured while fetching data please try again"
      );
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchPurchaserName = useCallback(
    debounce((purchaserId) => {
      if (purchaserId) {
        handlefetchPurchaserName(purchaserId);
      }
    }, 800),
    []
  );

  useEffect(() => {
    debouncedFetchPurchaserName(voucherPurchaseForm?.advocateBarId);
  }, [voucherPurchaseForm?.advocateBarId, debouncedFetchPurchaserName]);

  useEffect(() => {
    handleGetAllVoucherType();
    const inputElement = document.getElementById("totalAmount");
    if (inputElement) {
      inputElement.focus();
    }
  }, []);

  useEffect(() => {
    handleCalulateAmount();
  }, [voucherPurchaseForm?.quantity, voucherPurchaseForm.voucherId]);

  useEffect(() => {
    handleGetSoldVoucherDetailsByUserId();
    console.log(voucherDetailsList);
  }, [userId, refresh]);

  const formattedSoldVoucherData = voucherDateAndTimeFormatter(
    voucherDetailsList,
    ["voucherPurchaseDate"]
  );

  const formattedMissingVoucherData = voucherDateAndTimeFormatter(
    missingVoucherDetailsList,
    ["voucherMissingDate"]
  );

  useEffect(() => {
    setVoucherPurchaseForm({
      ...voucherPurchaseForm,
      userId: userId,
    });
    console.log("User Id From Login Session", voucherPurchaseForm.userId);
  }, [loading]);

  return (
    <>
      {loading && <Loader />}

      <div className="row mt-5 justify-content-center">
        <h3 className="text-center mb-5 text-uppercase">
          <b>Accounts</b>
        </h3>

        <div className="row justify-content-center">
          <div className="col-xxl-8 ">
            <div className="row justify-content-center">
              <div className="col-sm-6 col-md-4  col-xl-3 mt-auto">
                <label className="form-label ">Customer Type</label>
                <select
                  className="form-select  dropdown-height dropdown-width mdb-input-color"
                  name="customer__type"
                  value={customerType}
                  onChange={handleSelectCustomer}
                >
                  <option value="#">Select</option>
                  <option value="Vendor">Stamp Vendor</option>
                  <option value="Advocate">Advocate</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="col-sm-6 col-md-4  col-xl-3 mt-auto">
                <label className="form-label">Document Type</label>
                <select
                  className="form-select  dropdown-height dropdown-width mdb-input-color"
                  id="voucherType"
                  name="voucherType"
                  onChange={(event) => {
                    handleGetVoucherDetailsByVoucherId(event.target.value);
                  }}
                >
                  <option value="#" aria-readonly>
                    Select
                  </option>
                  {masterVoucherList.map((items, key) => (
                    <option value={items.voucherId} key={key}>
                      {items.voucherName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
                <MDBInputGroup
                  noWrap
                  textBefore={
                    bookAndSerialNo?.nextBookNo + bookAndSerialNo?.nextSerialNo
                  }
                >
                  <input
                    className="form-control"
                    name="voucherSrNo"
                    id="voucherSrNo"
                    type="number"
                    placeholder="Coupon Serial No"
                    value={voucherPurchaseForm?.providedSerialNo}
                    onChange={(event) => {
                      setVoucherPurchaseForm({
                        ...voucherPurchaseForm,
                        providedSerialNo: event.target.value,
                      });
                    }}
                  />
                </MDBInputGroup>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-xxl-8">
          <div className="row justify-content-center">
            <div className="col-sm-6 col-md-4  col-xl-3 mt-auto ">
              {customerType === "Vendor" && customerType === "Advocate"}
              {customerType === "Vendor" ? (
                <MDBInput
                  label={
                    purchaserName?.length > 1 && purchaserType === "Vendor"
                      ? purchaserName
                      : "Enter Id"
                  }
                  id="form1"
                  type="text"
                  onChange={(event) => {
                    setVoucherPurchaseForm({
                      ...voucherPurchaseForm,
                      advocateBarId: event.target.value,
                    });
                  }}
                />
              ) : (
                <MDBInput
                  label={
                    purchaserName?.length > 1 && purchaserType === "Advocate"
                      ? purchaserName
                      : "Enter Id"
                  }
                  id="advocateBarId"
                  name="advocateBarId"
                  type="text"
                  onChange={(event) => {
                    setVoucherPurchaseForm({
                      ...voucherPurchaseForm,
                      advocateBarId: event.target.value,
                    });
                  }}
                />
              )}
            </div>
            <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
              <MDBInput
                label="Quantity"
                id="quantity"
                name="quantity"
                type="number"
                title="Please enter a valid number"
                onChange={(event) => {
                  setVoucherPurchaseForm({
                    ...voucherPurchaseForm,
                    quantity: event.target.value,
                  });
                }}
                value={voucherPurchaseForm.quantity}
              />
            </div>

            <div className="col-sm-6 col-md-4  col-xl-3 mt-auto">
              <MDBInput
                readonly
                label="Total Amount"
                name="totalAmount"
                id="totalAmount"
                type="text"
                value={isNaN(totalAmount) ? "0" : totalAmount}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-xxl-8">
          <div className="row justify-content-center">
            <div className="col-md-3 d-flex justify-content-center">
              <MDBBtn
                onClick={() => {
                  handlePurchaseVoucher();
                }}
              >
                Submit
              </MDBBtn>
            </div>
          </div>
        </div>
      </div>

      {/* Table of voucher details by user id */}

      <div className="row justify-content-center mt-4">
        <div className="col-xxl-8">
          <div className="row justify-content-center">
            <div className="col">
              <MDBBtn
                onClick={() => {
                  handleGetSoldVoucherDetailsByUserId();
                }}
              >
                <FaClipboardList />
              </MDBBtn>{" "}
              &nbsp;
              <MDBBtn
                color="danger"
                onClick={() => {
                  handleGetMissingVoucherDetailsByUserId();
                }}
              >
                <GrDocumentMissing />
              </MDBBtn>
            </div>
          </div>
        </div>
      </div>
      {isMissingVoucherDetails ? (
        <VoucherDataTable
          TableColumns={missingVoucherTableColumns}
          TableData={formattedMissingVoucherData}
          tableName="Missing Voucher Table"
        />
      ) : (
        <VoucherDataTable
          TableColumns={soldVoucherTableColumns}
          TableData={formattedSoldVoucherData}
          tableName="Sold Voucher Table"
        />
      )}
    </>
  );
};

export default Accounts;
